"use client";

import { useSearchParams } from "next/navigation";
import { PropsWithChildren, ReactNode } from "react";

interface IPrivacyPoliciesLayoutProps {
	epicPrivacyPolicy: React.ReactNode;
	mobilePolicyPatient: React.ReactNode;
	mobilePolicyProvider: React.ReactNode;
}

const PrivacyPoliciesLayout: React.FC<PropsWithChildren<IPrivacyPoliciesLayoutProps>> = ({
	epicPrivacyPolicy,
	mobilePolicyPatient,
	mobilePolicyProvider,
	children,
}) => {
	const searchParams = useSearchParams();
	const tabsKey = "privacy-policy";
	const selectedPrivacyPolicyKey = searchParams?.get(tabsKey) || "";
	let selectedPrivacyPolicy: ReactNode;
	switch (selectedPrivacyPolicyKey) {
		case "mobile-policy-patient":
			selectedPrivacyPolicy = mobilePolicyPatient;
			break;
		case "mobile-policy-provider":
			selectedPrivacyPolicy = mobilePolicyProvider;
			break;
		default:
			selectedPrivacyPolicy = epicPrivacyPolicy;
			break;
	}

	return (
		<div className="grid" id="layout_about_privacypolicies">
			{children}
			<div className="pt-8 pb-12 md:pr-8">{selectedPrivacyPolicy}</div>
		</div>
	);
};
export default PrivacyPoliciesLayout;
